
const isDateOnlyString = (value) =>
    typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);

const parseDateInput = (value) => {
    if (value instanceof Date) return new Date(value);
    if (isDateOnlyString(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day);
    }
    return new Date(value);
};

// Moment format tokens for DD/MM/YYYY
const DATE_FORMAT = 'DD/MM/YYYY';
const DATETIME_FORMAT = 'DD/MM/YYYY hh:mm A';

// Safe date formatter — handles YYYY-MM-DD strings without timezone shift
const formatDisplayDate = (value) => {
    if (!value) return '-';
    const dateObj = parseDateInput(value);
    if (isNaN(dateObj.getTime())) return '-';
    return dateObj.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'America/Guyana',
    });
};

// Safe datetime formatter
const formatDisplayDateTime = (value) => {
    if (!value) return '-';
    const d = new Date(value);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'America/Guyana',
    });
};

const getMonthName = (date) => {
    const dateObj = parseDateInput(date);
    return dateObj.toLocaleString('en-GB', { month: 'short', timeZone: 'America/Guyana' });
}

const getDayName = (date) => {
    const dateObj = parseDateInput(date);
    return dateObj.toLocaleString('en-GB', { day: 'numeric', timeZone: 'America/Guyana' });
}

const getYear = (date) => {
    const dateObj = parseDateInput(date);
    return dateObj.toLocaleString('en-GB', { year: 'numeric', timeZone: 'America/Guyana' });
}

const getTime = (date) => {
    const dateObj = parseDateInput(date);
    return dateObj.toLocaleTimeString('en-US', { timeZone: 'America/Guyana' });
}

const generateFullDate = (date) => {
    return formatDisplayDate(date);
}

export {
    getMonthName,
    getDayName,
    generateFullDate,
    getTime,
    parseDateInput,
    DATE_FORMAT,
    DATETIME_FORMAT,
    formatDisplayDate,
    formatDisplayDateTime
}
